import { MinusCircleOffOutlineIcon } from './MinusCircleOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2A82D040-8856-437D-B478-DF448C7BE6A6
 * name minus-circle-off-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle-off-outline.svg
 * tags
 */
export const DoNotEnterOffOutlineIcon = MinusCircleOffOutlineIcon;
export default DoNotEnterOffOutlineIcon